import countries from "world-countries";
import { getCountryCallingCode, CountryCode } from "libphonenumber-js";

export interface CountryOption {
  code: CountryCode;
  name: string;
  dialCode: string;
  flag: string;
}

export const COUNTRIES: CountryOption[] = countries
  .map((c) => {
    const code = c.cca2 as CountryCode;
    try {
      return {
        code,
        name: c.name.common,
        dialCode: `+${getCountryCallingCode(code)}`,
        flag: c.flag,
      };
    } catch {
      return null;
    }
  })
  .filter((c): c is CountryOption => c !== null)
  .sort((a, b) => a.name.localeCompare(b.name));